import {React,useState, useEffect} from 'react';
import './Loginpage.css';
// import image from "./img/vehicle-banner.jpg";
import image from "./img/OneClick-Login-V1.jpg";
import mobileImageLogin from "./img/OneClick-Login-Mobile.png";
import image2 from "./img/switch.png";
import bggif from "./img/BG-switch loader_2.gif";
import image1 from "./img/Connect-Switch.png";
import axios from 'axios'
import { Button, FormControl } from "@mui/material";
import CryptoJS from "crypto-js";
import { JSEncrypt } from "jsencrypt";
import {ACCESSVENDOR,UPDATEMOBILE,TEMPUSER,VENDORLOGINS,GETTOKEN,NEWLOGIN} from '../../Pages/AppConstant'



function LoginPage(){
    
    const [empId,SetEmpId]=useState("")
    const [mobileno,SetMobileno]=useState("")
    const [password,SetPassword]=useState("")
    const [data,setData] = useState([])
    const [incorrectText,SetIncorrectText] = useState("")
    const[isloading,Setisloading] = useState(false)
    const [ismodelopen,SetIsmodelopen]=useState(false)
    const [bgImageLogin, setBgImage] = useState('')

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      const mobileImage = mobileImageLogin;
      const desktopImage = image;
      setBgImage(isMobile ? mobileImage : desktopImage);
    };

    handleResize(); // Set on load
    window.addEventListener('resize', handleResize); // Update on resize

    return () => window.removeEventListener('resize', handleResize);
  }, []);

    useEffect(() => {
      getsession();            
      // fetchapprovaldata();
      }, []);
    const getsession=()=>{
      localStorage.setItem('sessions', "notactive");
      }
    const callvendorfn = ()=>{
      // if(/^\d+$/.test(password)===true){
      axios.post(ACCESSVENDOR, {"switch_code" : empId,"mobile":password})
      .then(function (response) {
        //console.log("SuccessFully updated");
        if(response.data.data=="Valid User"){
          Setisloading(false)
          SetIsmodelopen(true)
        }else if(response.data.data=="success"){
          if(response.data.verified=="Yes"){
            console.log(response.data);
            localStorage.setItem('type', "Offrole");
            localStorage.setItem('empid', empId.toUpperCase());
            localStorage.setItem('empname', response.data.username);
            localStorage.setItem('emailid', response.data.emailid);
             localStorage.setItem('dept', response.data.dept);
            
            window.location.href = "/landingPage"
            localStorage.setItem('sessions', "isactive");
          }else{
            localStorage.setItem('empid', empId.toUpperCase());
            window.location.href = "/userdata"
          }

          
        }
        else{
           Setisloading(false)
          alert("Please enter the valid username and password")
        }
       
      })
        .catch(function (error) {
          console.log(error);
        });
    
           
    }
    const calltempuser =()=>{
      axios.post(TEMPUSER, {"login_ids" : empId,"password":password})
      .then(function (response) {
        if(response.data=="Valid User"){
          localStorage.setItem('type', "Onrole");
          localStorage.setItem('sessions', "isactive");
         window.location.href = "/landingPage"
        }
        else{
          callvendorfn();
        }
       
      })
        .catch(function (error) {
          console.log(error);
        });
       
    }
  
  
   
    const Updatemobile=()=>{
      if(mobileno.length===10){
      axios({
        method: 'get',
        url: UPDATEMOBILE,
        withCredentials: false,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
        params:{"switch_code" : empId,"mobile":mobileno}
      }).then(response => {
        console.log(response.data)
        if(response.data.data==="SuccessFully updated"){
          SetIsmodelopen(false)
           localStorage.setItem('empid', empId.toUpperCase());
           localStorage.setItem('type', "Offrole");
           localStorage.setItem('managerid', response.data.Manager_id);
           localStorage.setItem('sessions', "isactive");
           window.location.href = "/landingPage"
        }else{
          alert("Please try again later")
          SetIsmodelopen(false)
        }
     
       

    })
      .catch(function (error) {
        console.log(error);
      });}
      else{
        alert("Please enter the valid mobile number")
      }
      
    }

    const callvendorlogin=()=>{
      axios.post(VENDORLOGINS, {"login_ids" : empId,"password":password})
      .then(function (response) {
        //console.log("SuccessFully updated");
        if(response.data=="Valid User"){
         
         window.location.href = "/vendormaster"
         localStorage.setItem('vendordata',empId)
         localStorage.setItem('vendorlogin',"isactive")
         localStorage.setItem('sessions', "isactive");
        }
        else{
          ClickLogin();
          // localStorage.setItem('vendorlogin',"inactive")
          // localStorage.setItem('sessions', "isactive");
          //  window.location.href = "/landingPage"
        }
      })
      .catch(function (error) {
        console.log(error);


        
      });
    }

    const ClickLogin = async()=>{
      Setisloading(true)
      if(password !== "" && empId !== ""){        
      const keyResponse = await axios.get(GETTOKEN);      
      const publicKey = keyResponse.data.public_key;
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKey);
      const encryptedUsername = encrypt.encrypt(empId);
      const encryptedPassword = encrypt.encrypt(password);
      const dataess = await axios.post(
      NEWLOGIN,{username: encryptedUsername,password: encryptedPassword
          }
        );
        console.log(dataess)
        if(dataess.data.status_code===200){
          const userdatas = dataess.data.data[0];
           localStorage.setItem('emailid', userdatas.mail[0]);
              localStorage.setItem('empname', userdatas.displayName[0]);
              localStorage.setItem('empid', userdatas.employeeID[0]);
              localStorage.setItem('dept',userdatas.department[0])
               var fhname = userdatas.pager[0]             
              let results = fhname.split("@");
              localStorage.setItem('reporting_managername',results[0])
              localStorage.setItem('reporting_manageremail',userdatas.pager[0])
              localStorage.setItem('reporting_managerempid',userdatas.homePhone[0])
              localStorage.setItem('worklocation',userdatas.l[0])            
              var fhdata = userdatas.facsimileTelephoneNumber[0]             
              let result = fhdata.split("-");
              var fhname = result[1]             
              let result12 = fhname.split("@");
              localStorage.setItem('functionheadname',result12[0]) 
              localStorage.setItem('functionheademail',result[1])
              localStorage.setItem('functionheadempid',result[0])             
              localStorage.setItem('type', "Onrole");
              localStorage.setItem('sessions', "isactive");
              window.location.href = "/landingPage"
        }else{
           calltempuser();
        }
      
       
    }
    else{
      Setisloading(false)
        alert("Please Enter Value")
    }
      
           
      
    }
    const callclose=()=>{
      SetIsmodelopen(false)
    }

    return(
        <div className="login-wrap login-bg-img" style={{ backgroundImage:`url(${bgImageLogin})`,backgroundRepeat:"no-repeat" }}>
          {isloading?<div className="loader-gif">
          <img  style={{paddingTop:"20%"}}src={bggif}  alt="fireSpot"/>
          </div>:''}
          {ismodelopen?
          <div id="myModal" class="modal-one"> 
            <div class="modal-content-one">
              <span class="close-one" onClick={()=>callclose()}>&times;</span>
              <p>Enter Mobile No.</p>
              <input
              type="number"
              className="m-2 setdesign"
              onChange={(e)=>SetMobileno(e.target.value)}
              placeholder="Mobile no"
              name="Mobile"
              max="10"
              onKeyDown={(e) => {if (e.key === "Enter") Updatemobile();}}
            />
            <p className='note-css'>Note: Mobile No. you entered will serve as your password for future logins.</p>
             <Button className="button-design"  onClick={() => {Updatemobile()}}>
              Submit
            </Button>
            </div>
          </div>:''}
          <div className="new-login-box">
        
          <div >
            <i className="fa fa-user icon"></i>
            <input
              className="m-2 setdesign"
              onChange={(e)=>SetEmpId(e.target.value)}
              placeholder="windows ID"
              name="email"
            />
          </div>
          <div style={{ paddingBottom: "9px" }} >
            <input
              className="m-2 setdesign" 
              onChange={(e)=>SetPassword(e.target.value)}             
              placeholder="Password"              
              name="password"
              type="password"
              onKeyDown={(e) => {if (e.key === "Enter") callvendorlogin();}}
            ></input>
            
          </div>
          <div className="m-2">
            <Button className="button-design"  onClick={() => {callvendorlogin()}}>
              Submit
            </Button>
           
          </div>
         
          </div>
         
        </div>
    )
}

export default LoginPage